import { render, staticRenderFns } from "./corporateEquity.vue?vue&type=template&id=5c70f5ce&scoped=true"
import script from "./corporateEquity.vue?vue&type=script&lang=js"
export * from "./corporateEquity.vue?vue&type=script&lang=js"
import style0 from "./corporateEquity.vue?vue&type=style&index=0&id=5c70f5ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c70f5ce",
  null
  
)

export default component.exports